document.addEventListener('easysearch_rendered', function (e){
  easysearch.widgetSelectorForCustomSelects = '.easysearch-widget';

  function initCustomSelects()
  {
    let easyOpenBtn = easysearch.jq('.easy-video-container .easysearch-btn-holder');
    easyOpenBtn.on('click', function () {
      let selectItem = easysearch.jq('.easy-video-container .easysearch-select-holder:first .select-styled');
      selectItem.click();
    })
    let easyOpenBtnSecond = easysearch.jq('.easy-text_icons-container .easysearch-btn-holder');
    easyOpenBtnSecond.on('click', function () {
      let selectItemSecond = easysearch.jq('.easy-text_icons-container .easysearch-select-holder:first .select-styled');
      selectItemSecond.click();
    })
    let easyOpenBtnThird = easysearch.jq('.easy-third-home-container .easysearch-btn-holder');
    easyOpenBtnThird.on('click', function () {
      let selectItemThird = easysearch.jq('.easy-third-home-container .easysearch-select-holder:first .select-styled');
      selectItemThird.click();
    })
    easysearch.jq(easysearch.widgetSelectorForCustomSelects).find('.easysearch-select-holder > select').each(function(i, el){
      var $this = easysearch.jq(this);
      var $holder = $this.parent().closest('.easysearch-holder');

      $this.addClass('select-hidden');
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"><span class="select-styled-text"></span><span class="select-styled-arrow"></span></div>');

      var $styledSelect = $this.next('div.select-styled');
      var $list = easysearch.jq('<ul />', {'class': 'select-options'}).insertAfter($styledSelect);

      $styledSelect.click(function(e) {
        e.stopPropagation();
        easysearch.jq('div.select-styled.active').not(this).each(function(){
          easysearch.jq(this).removeClass('active');
        });
        easysearch.jq(this).toggleClass('active');
      });

      easysearch.jq(document).click(function() {
        //$styledSelect.removeClass('active');
      });

      document.addEventListener('easysearch_loaded', function (e){
        initCustomSelectsOptions( $this, $styledSelect, $list );
      });

      initCustomSelectsOptions( $this, $styledSelect, $list );
    });
  }

  function initCustomSelectsOptions( $sel, $styledSelect, $list )
  {
    $list.empty();
    $styledSelect.children('.select-styled-text').text( ($sel.children('option:selected').length) ? $sel.children('option:selected').text() : $sel.children('option').eq(0).text() );

    var numberOfOptions = $sel.children('option').length;
    for (var i = 0; i < numberOfOptions; i++) {
        easysearch.jq('<li />', {
            text: $sel.children('option').eq(i).text(),
            rel: $sel.children('option').eq(i).val()
        }).appendTo($list);
    }

    var $listItems = $list.children('li');
    $listItems.click(function(e) {
      e.stopPropagation();
      var $holder = $(this).parent().closest('.easysearch-holder');
      $styledSelect.removeClass('active').children('.select-styled-text').text(easysearch.jq(this).text());
      $sel.val(easysearch.jq(this).attr('rel')).trigger('change');

      var $selectHolder = $styledSelect.parent().closest('.easysearch-select-holder');
      var $nextSelectHolder = $selectHolder.next('.easysearch-select-holder');
      if( $nextSelectHolder.length ) $nextSelectHolder.find('.select-styled').addClass('active');

      setTimeout(function(){
        $holder.find('.easysearch-select-holder .select').each(function(){
          var $sel  = easysearch.jq(this).children('select:first');
          var $styledSelect = easysearch.jq(this).children('.select-styled:first');
          var $list = easysearch.jq(this).children('.select-options:first');
          initCustomSelectsOptions( $sel, $styledSelect, $list );
        });
      }, 50);
    });
  }

  initCustomSelects();
});


document.addEventListener('easysearch_loaded', function (){ 
    const easyBtn = document.querySelector(".easy-video-container .easysearch-btn-holder");
    const insertPlace = document.querySelector('.easy-video-container .easysearch-holder').children[0];
    const insertParentPlace = document.querySelector('.easy-video-container .easysearch-holder');
      if(easyBtn && insertPlace && insertParentPlace){
        insertParentPlace.insertBefore(easyBtn, insertPlace);
      }
    const easyBtnSec = document.querySelector(".easy-text_icons-container .easysearch-btn-holder");
    const insertPlaceSec = document.querySelector('.easy-text_icons-container .easysearch-holder').children[0];
    const insertParentPlaceSec = document.querySelector('.easy-text_icons-container .easysearch-holder');
      if(easyBtnSec && insertPlaceSec && insertParentPlaceSec){
        insertParentPlaceSec.insertBefore(easyBtnSec, insertPlaceSec);
      }
    const easyBtnThird = document.querySelector(".easy-third-home-container .easysearch-btn-holder");
    const insertPlaceThird = document.querySelector('.easy-third-home-container .easysearch-holder').children[0];
    const insertParentPlaceThird = document.querySelector('.easy-third-home-container .easysearch-holder');
      if(easyBtnThird && insertPlaceThird && insertParentPlaceThird){
        insertParentPlaceThird.insertBefore(easyBtnThird, insertPlaceThird);
      }
    let insertMobileContainer = document.querySelector('.easy-slideshow-mobile-container');
    let easysearchForm = document.querySelector('.easy-slideshow-container .easysearch-widget');
    if(insertMobileContainer && easysearchForm && window.innerWidth < 769){
      insertMobileContainer.append(easysearchForm);
    }
}); 